import React, {useEffect, useRef, useState} from 'react'
import styles from './IdeationSetupIdea.module.scss'
import {WuButton, WuIcon, WuInput} from '@npm-questionpro/wick-ui-lib'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {IDEATION} from '../../../../../Translation/English/ideation'

interface IIdea {
  id: string
  text: string
  focus?: boolean
}

interface IIdeationSetupIdeaProps {
  idea: IIdea
  index: number
  disabled: boolean
  addIda: (index: number) => void
  removeIda: (id: string) => void
  handleChangeIdeaTitle: (idea: {id: string; text: string}) => void
  saveNewIdeas: () => void
}

export const IdeationSetupIdea: React.FC<IIdeationSetupIdeaProps> = ({
  idea,
  index,
  disabled,
  addIda,
  removeIda,
  handleChangeIdeaTitle,
  saveNewIdeas,
}) => {
  const inputQuestionRef = useRef<HTMLInputElement>(null)
  const wt = useWt()
  const [title, setTitle] = useState<string>(idea.text)

  const handleChangeTitle = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setTitle(e.target.value)
    handleChangeIdeaTitle({id: idea.id, text: e.target.value})
  }

  useEffect(() => {
    if (idea.focus) {
      inputQuestionRef?.current?.focus()
    }
  }, [idea.focus, inputQuestionRef])

  return (
    <div className={styles.ideaFlowIdea}>
      <WuInput
        ref={inputQuestionRef}
        placeholder={`${wt(IDEATION.idea)} ${index + 1}`}
        value={title}
        disabled={disabled}
        onChange={handleChangeTitle}
        onBlur={() => (title.length ? saveNewIdeas() : {})}
      />

      <WuButton
        variant="secondary"
        className={styles.ideaFlowIdeaBtn}
        disabled={disabled}
        onClick={() => addIda(index + 1)}
        Icon={<WuIcon icon="wm-add" />}
      />

      <WuButton
        variant="secondary"
        className={styles.ideaFlowIdeaBtn}
        onClick={() => removeIda(idea.id)}
        disabled={disabled}
        Icon={<WuIcon icon="wm-remove" />}
      />
    </div>
  )
}
